import { ChevronDownIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface ChevronToggleProps {
  isOpen: boolean;
  direction?: 'horizontal' | 'down';
  className?: string;
}

export function ChevronToggle({ isOpen, direction = 'horizontal', className }: ChevronToggleProps) {
  const rotation =
    direction === 'down'
      ? isOpen
        ? 'rotate-180'
        : 'rotate-0'
      : isOpen
        ? 'rotate-0'
        : '-rotate-90';

  return (
    <ChevronDownIcon
      className={cn(
        'size-4 shrink-0 transition-transform duration-200 ease-out',
        rotation,
        className,
      )}
    />
  );
}
